import React, { useEffect, useState, useRef, useCallback } from "react";

export const Addresses = (props) => {

  const companyInfo = props.companyData;

  return (
    <>
      <div id="contacts" className="mainContentData">
        <br></br>
        {/* <div className="col-lg-12 px-0">
          <div className="row m-0">
            <div className="col-md-3">
              <div className="mb-4">
                <span className="fw-medium custom-font-size">Address</span>
              </div>
            </div>
          </div>
        </div> */}
        {/* <div className="col-lg-12 px-0">
          <div className="row m-0 gap-5">
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium"> Address 1</span>
                <p className="fw-medium mb-0">
                  {companyInfo.homeAddressStreet1 || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium"> Province</span>
                <p className="fw-medium mb-0">
                  {companyInfo.homeProvince || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium"> Address 2</span>
                <p className="fw-medium mb-0">
                  {companyInfo.homeAddressStreet2 || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium"> Country</span>
                <p className="fw-medium mb-0">
                  {companyInfo.homeCountry || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium"> City</span>
                <p className="fw-medium mb-0">{companyInfo.homeCity || "-"}</p>
              </div>
              <div className="mb-4">
                <span className="fw-medium">Notes</span>
                <p className="fw-medium mb-0">{companyInfo.homeNote || "-"}</p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium"> State</span>
                <p className="fw-medium mb-0">{companyInfo.homeState || "-"}</p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">Zip</span>
                <p className="fw-medium mb-0">{companyInfo.homeZip || "-"}</p>
              </div>
            </div>
          </div>
        </div> */}
        <hr />
        <div className="col-lg-12 px-0">
          <div className="row m-0">
            <div className="col-md-3">
              <div className="mb-4">
                <span className="fw-medium custom-font-size">
                  Business Address
                </span>
                <p className="fw-medium mb-0"></p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12 px-0">
          <div className="row m-0 gap-5">
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">Address 1</span>
                <p className="fw-medium mb-0">
                  {companyInfo.businessAddressStreet1 || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium">Province</span>
                <p className="fw-medium mb-0">
                  {companyInfo.businessProvince || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">Address 2</span>
                <p className="fw-medium mb-0">
                  {companyInfo.businessAddressStreet2 || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium">Country</span>
                <p className="fw-medium mb-0">
                  {companyInfo.businessCountry || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">City</span>
                <p className="fw-medium mb-0">
                  {companyInfo.businessCity || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium">Notes</span>
                <p className="fw-medium mb-0">
                  {companyInfo.businessNote || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">State</span>
                <p className="fw-medium mb-0">
                  {companyInfo.businessState || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium"> Zip</span>
                <p className="fw-medium mb-0">
                  {companyInfo.businessZip || "-"}
                </p>
              </div>
            </div>
          </div>
        </div>
        <hr />
        {/* <div className="col-lg-12 px-0">
          <div className="row m-0">
            <div className="col-md-3">
              <div className="mb-4">
                <span className="fw-medium custom-font-size">
                  Statement Address
                </span>
                <p className="fw-medium mb-0"></p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12 px-0">
          <div className="row m-0 gap-5">
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">Address 1</span>
                <p className="fw-medium mb-0">
                  {companyInfo.statementAddressStreet1 || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium">Province</span>
                <p className="fw-medium mb-0">
                  {companyInfo.statementAddressProvince || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">Address 2</span>
                <p className="fw-medium mb-0">
                  {companyInfo.statementAddressStreet2 || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium">Country</span>
                <p className="fw-medium mb-0">
                  {companyInfo.statementAddressCountry || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">City</span>
                <p className="fw-medium mb-0">
                  {companyInfo.statementAddressCity || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium">Notes</span>
                <p className="fw-medium mb-0">
                  {companyInfo.statementNote || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">State</span>
                <p className="fw-medium mb-0">
                  {companyInfo.statementAddressState || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">Zip</span>
                <p className="fw-medium mb-0">
                  {companyInfo.statementAddressZip || "-"}
                </p>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};
